import type {
  DerivedEventLegacy,
  SimpleEventLegacy,
  SubjectVariableLegacy,
} from '@verantos-dev/types-cohorts';

type DuplicateNamesCountMap = { [name: string]: number };

/**
 * This function will validate the current cohort definition and determine whether it is valid for processing.
 *
 * @param {SubjectVariable[]} subjectVariables - the current cohort builder definition's subject variables to validate
 * @returns {
 *  hasDuplicateName: boolean,
 *  duplicateNames: string[],
 *  names: { [name: string]: number }
 * }
 * - hasDuplicateName: true if the cohort definition has duplicate names, false otherwise
 * - names: an object containing the names and the number of times they appear
 */
export const validateForDuplicateNames = (
  subjectVariables: SubjectVariableLegacy[],
  derivedEvents: DerivedEventLegacy[],
  simpleEvents: SimpleEventLegacy[]
) => {
  let hasDuplicateName = false;
  const names: DuplicateNamesCountMap = {};

  subjectVariables?.forEach(({ name }) => {
    hasDuplicateName = handleDuplicateNames(name, names) || hasDuplicateName;
  });

  derivedEvents?.forEach(({ name }) => {
    hasDuplicateName = handleDuplicateNames(name, names) || hasDuplicateName;
  });

  simpleEvents?.forEach(({ name }) => {
    hasDuplicateName = handleDuplicateNames(name, names) || hasDuplicateName;
  });

  return { hasDuplicateName, names };
};

const handleDuplicateNames = (nameToCheck: string, names: DuplicateNamesCountMap) => {
  const formattedNameToCheck = nameToCheck.trim().toLowerCase();
  // check if name was already defined
  if (names[formattedNameToCheck]) {
    // increment name count
    names[formattedNameToCheck] += 1;
    return true;
  }
  // add name to names object
  names[formattedNameToCheck] = 1;
  return false;
};
